import React, { useEffect, useState } from 'react'
import { Button, Modal, Form, Toast } from '@themesberg/react-bootstrap'

export default function ChargeUserFormModal({
  show,
  mode,
  chargeUser,
  isSuperAdmin,
  admins = [],
  onHide,
  onSubmit,
}) {
  const isEdit = mode === 'edit'

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [name, setName] = useState('')
  const [adminId, setAdminId] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!show) return
    setError('')
    setPassword('')
    if (isEdit && chargeUser) {
      setUsername(chargeUser.username || '')
      setName(chargeUser.name || '')
      setAdminId(chargeUser.adminId || '')
    } else {
      setUsername('')
      setName('')
      setAdminId('')
    }
  }, [show, isEdit, chargeUser])

  const handleSubmit = async () => {
    setError('')

    if (!username || !name) {
      setError('Username và tên hiển thị là bắt buộc')
      return
    }

    if (!isEdit && (!password || password.length < 6)) {
      setError('Mật khẩu tối thiểu 6 ký tự')
      return
    }

    const payload = {
      username: username.trim(),
      name: name.trim(),
    }

    if (!isEdit) {
      payload.password = password
      payload.status = 1
      if (isSuperAdmin) {
        payload.adminId = adminId || null
      }
    } else {
      payload.id = chargeUser.id
      if (isSuperAdmin) {
        payload.adminId = adminId || null
      }
    }

    const result = await onSubmit(payload)
    if (result?.error) {
      setError(result.message || 'Có lỗi xảy ra')
      return
    }
    onHide(true)
  }

  return (
    <Modal show={show} onHide={() => onHide(false)} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Sửa user nạp tiền' : 'Thêm user nạp tiền'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Toast show className="d-block mb-3" bg="danger">
            <Toast.Body className="text-white">{error}</Toast.Body>
          </Toast>
        )}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>
          {!isEdit && (
            <Form.Group className="mb-3">
              <Form.Label>Mật khẩu</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
              />
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Tên hiển thị</Form.Label>
            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} required />
          </Form.Group>
          {isSuperAdmin && (
            <Form.Group className="mb-3">
              <Form.Label>Admin sở hữu</Form.Label>
              <Form.Select value={adminId} onChange={(e) => setAdminId(e.target.value)}>
                <option value="">— Chưa gán —</option>
                {admins.map((admin) => (
                  <option key={admin.id} value={admin.id}>
                    {admin.name ? `${admin.name} (${admin.email})` : admin.email}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Đóng
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {isEdit ? 'Lưu' : 'Thêm'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
